const GHOST_INTERACTION_MS = 400;

export function suppressGhostInteractionAtPoint({
  clientX,
  clientY,
}: {
  clientX: number;
  clientY: number;
}): void {
  const shield = document.createElement("div");
  shield.setAttribute("aria-hidden", "true");
  Object.assign(shield.style, {
    position: "fixed",
    inset: "0",
    zIndex: "9999",
  });

  const removeShield = () => {
    shield.remove();
  };

  const block = (event: Event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  for (const type of ["pointerdown", "pointerup", "click"] as const) {
    shield.addEventListener(type, block);
  }
  shield.addEventListener("pointerup", removeShield, { once: true });
  shield.addEventListener("click", removeShield, { once: true });
  window.setTimeout(removeShield, GHOST_INTERACTION_MS);

  document.body.appendChild(shield);

  window.setTimeout(() => {
    if (!shield.isConnected) return;
    shield.style.pointerEvents = "none";
    const target = document.elementFromPoint(clientX, clientY);
    shield.style.pointerEvents = "";
    if (!(target instanceof HTMLElement)) return;
    target.blur();
    for (const type of ["pointerout", "pointerleave", "mouseout", "mouseup"] as const) {
      target.dispatchEvent(
        new MouseEvent(type, { bubbles: true, cancelable: true, clientX, clientY, view: window }),
      );
    }
  }, 0);
}
